﻿import { motion } from 'framer-motion';
import Icon from 'components/AppIcon';

const DevToolsBlocker = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-white to-secondary-50/50" />

      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="relative z-10 flex flex-col items-center px-4 text-center max-w-md"
      >
        <div className="mb-8 relative">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 200, damping: 15 }}
            className="h-24 w-24 rounded-3xl bg-red-50 flex items-center justify-center text-red-500 shadow-sm"
          >
            <Icon name="ShieldAlert" size={48} strokeWidth={1.5} />
          </motion.div>
          <div className="absolute -bottom-2 -right-2 h-8 w-8 rounded-full bg-white shadow-md flex items-center justify-center text-red-600">
            <Icon name="Lock" size={16} />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-slate-900 tracking-tight">
          Security Access Restricted
        </h1>

        <p className="mt-4 text-slate-600 text-lg leading-relaxed">
          To ensure the security and integrity of your data, the use of Developer Tools is
          restricted in this environment.
        </p>

        <div className="mt-8 p-4 rounded-2xl bg-amber-50 border border-amber-100 flex items-start gap-3 text-left">
          <div className="mt-1 text-amber-600 shrink-0">
            <Icon name="Info" size={20} />
          </div>
          <p className="text-sm text-amber-800 leading-snug">
            Please{' '}
            <span className="font-bold text-amber-900 underline decoration-amber-500/30">
              close the Developer Tools
            </span>{' '}
            panel to immediately resume using the application.
          </p>
        </div>

        <motion.div
          animate={{ opacity: [0.4, 0.7, 0.4] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="mt-12 text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-400"
        >
          Security Enforcement Active
        </motion.div>
      </motion.div>
    </div>
  );
};

export default DevToolsBlocker;
